import { render, staticRenderFns } from "./measurements.vue?vue&type=template&id=396e902e"
import script from "./measurements.vue?vue&type=script&lang=js"
export * from "./measurements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports